export const DetailController = {
    show(): void {},
};
